import React, { memo } from 'react'

interface IFeedbackMessage {
  message: string
  type: string
}

export const FeedbackMessage = memo<IFeedbackMessage>(({ message, type = 'default' }) => {
  const className = `text-${type}`
  return <p className={className}>{message}</p>
})
